class CustomProductSizeChart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(".custom-product-size-chart")
        .unbind()
        .click(function () {
          $(".custom-complementary-products").show(200);
          $("body").css({ overflow: "hidden" });
        });

      $(".custom-complementary-close")
        .unbind()
        .click(function () {
          $(".custom-complementary-products").hide(200);
          $("body").css({ overflow: "unset" });
        });

      $(".custom-complemetary-overlay")
        .unbind()
        .click(function () {
          $(".custom-complementary-products").hide(200);
          $("body").css({ overflow: "unset" });
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-product-size-chart", CustomProductSizeChart);

class CustomShippingTime extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var timeinfo = $(this).data("shiptime");
      var countdownDuration = timeinfo * 60 * 1000;
      var intervalTime = 1000;

      function getEndTime() {
        var endTime = localStorage.getItem("countdown_end_time");
        if (!endTime) {
          var currentTime = Date.now();
          var newEndTime = currentTime + countdownDuration;
          localStorage.setItem("countdown_end_time", newEndTime);
          return newEndTime;
        }
        return parseInt(endTime, 10);
      }

      function updateCounter() {
        var endTime = getEndTime();
        var currentTime = Date.now();
        var timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
          localStorage.setItem(
            "countdown_end_time",
            currentTime + countdownDuration
          );
          timeLeft = countdownDuration;
        }

        var minutesLeft = Math.floor(timeLeft / (1000 * 60));
        var secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);

        var formattedMinutes =
          minutesLeft < 10 ? "0" + minutesLeft : minutesLeft;
        var formattedSeconds =
          secondsLeft < 10 ? "0" + secondsLeft : secondsLeft;

        $(".customtimedata").text(formattedMinutes + ":" + formattedSeconds);
      }

      setInterval(updateCounter, intervalTime);
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-shipping-time", CustomShippingTime);

class CustomStickyAtc extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(document).ready(function () {
        const $boxes = $(".product-detail-atc-info-main");
        const $stickyContainer = $(".custom-sticky-atc-button-container");

        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        };

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            console.log(entry.target.id, entry.isIntersecting);

            if (entry.isIntersecting) {
              $stickyContainer.fadeOut(200);
            } else {
              $stickyContainer.fadeIn(200);
            }
          });
        }, observerOptions);

        // Observe each $boxes element
        $boxes.each(function () {
          observer.observe(this);
        });

        $(".sticky-addtocart-button")
          .unbind()
          .click(function () {
            $(".custom-buy-button-atc").click();
          });
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-sticky-atc-container", CustomStickyAtc);

class ProductImagewithText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      setTimeout(function () {
        $(".product-image-with-content-main").css({ opacity: "1" });
      }, 1000);

      let swiper;
      var autoplay = $(this).data("autoplay");
      function initSwiper() {
        if (window.innerWidth >= 768) {
          if (!swiper) {
            if (autoplay == true) {
              swiper = new Swiper(".product-image-with-text-slider", {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
              });
            } else {
              swiper = new Swiper(".product-image-with-text-slider", {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                pagination: {
                  el: ".swiper-pagination",
                },
              });
            }
          }
        } else {
          if (swiper) {
            swiper.destroy(true, true);
            swiper = undefined;
          }
        }
      }
      initSwiper();
      window.addEventListener("resize", () => {
        initSwiper();
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("product-image-with-text", ProductImagewithText);

class ProductImagewithTextNew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      setTimeout(function () {
        $(".product-image-with-content-main").css({ opacity: "1" });
      }, 1000);

      let swiper;
      var autoplay = $(this).data("autoplay");
      function initSwiper() {
        if (window.innerWidth >= 768) {
          if (!swiper) {
            if (autoplay == true) {
              swiper = new Swiper(".product-image-with-text-slider", {
                slidesPerView: 6,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
              });
            } else {
              swiper = new Swiper(".product-image-with-text-slider", {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                pagination: {
                  el: ".swiper-pagination",
                },
              });
            }
          }
        } else {
          if (swiper) {
            swiper.destroy(true, true);
            swiper = undefined;
          }
        }
      }
      initSwiper();
      window.addEventListener("resize", () => {
        initSwiper();
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("product-image-with-text-new", ProductImagewithTextNew);

class CustomRelatedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(this).css({ opacity: "1" });
      var filtercustom = new Swiper(
        ".swiper-container-product-" + this.getAttribute("data-sectionid"),
        {
          spaceBetween: 20,
          slidesPerView: 5,
          breakpoints: {
            660: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1441: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }
      );
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-related-product", CustomRelatedProduct);

class CustomLogoSlide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      // Initialize Swiper
      const swiperLogoContainer = ".swiper-logo-" + this.getAttribute("data-sectionid");
      const filtercustomlogos = new Swiper(swiperLogoContainer, {
        spaceBetween: 30,
        slidesPerView: 8,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        speed: 5000,
        breakpoints: {
          580: { slidesPerView: 2, spaceBetween: 10 },
          680: { slidesPerView: 3, spaceBetween: 20 },
          767: { slidesPerView: 4, spaceBetween: 20 },
          1025: { slidesPerView: 4, spaceBetween: 20 },
          1200: { slidesPerView: 5, spaceBetween: 20 },
          1400: { slidesPerView: 6, spaceBetween: 20 },
          1600: { slidesPerView: 6, spaceBetween: 30 },
          1800: { slidesPerView: 7, spaceBetween: 30 },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      // Hover event to stop/start autoplay
      $(swiperLogoContainer)
        .on("mouseenter", function () {
          //filtercustomlogos.swiper.autoplay.stop();
        })
        .on("mouseleave", function () {
          //filtercustomlogos.swiper.autoplay.start();
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("logo-section", CustomLogoSlide);

